// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ib-z","heading":"Jb-z","brandPromo":"Kb-z"};